import React from 'react';
import './Trading.css';

export const BOT_ADDRESS = '0xfb8693369A04a506239aB97dC762222AB6A07EA7';

export const TRADING_LINKS = [
  {
    id: 'hypurrscan',
    name: 'Hypurrscan',
    url: `https://hypurrscan.io/address/${BOT_ADDRESS}`,
    description: 'Positions, open orders, trade history and P&L. The closest thing to a portfolio page.',
  },
  {
    id: 'hyperliquid',
    name: 'Hyperliquid Explorer',
    url: `https://app.hyperliquid.xyz/explorer/address/${BOT_ADDRESS}`,
    description: 'On-chain explorer view of the bot wallet on Hyperliquid.',
  },
];

const TradingPage = () => (
  <div className="trading-page">
    <header className="tr-hero">
      <h2>Trading</h2>
      <p className="tr-sub">Trading bot wallet on Hyperliquid</p>
      <p className="tr-address" title={BOT_ADDRESS}>
        {BOT_ADDRESS}
      </p>
    </header>

    <section className="tr-links">
      {TRADING_LINKS.map((link) => (
        <a key={link.id} className="tr-link" href={link.url} target="_blank" rel="noreferrer">
          <div className="tr-link-name">{link.name}</div>
          <div className="tr-link-desc">{link.description}</div>
          <div className="tr-link-open">Open ↗</div>
        </a>
      ))}
    </section>
  </div>
);

export default TradingPage;
